module.exports = __webpack_public_path__ + "img/hero-icon.125640cd.svg";